import { appComponentAccessId } from 'app/layout/Layout';
import { Location } from 'react-router-dom';

export const redirectToCandidateContractDocEditor = (history, location: Location, options?: { defaultSelection: string }) => {
  /** Code: Switch view to candidate-contract-editor */
  const searchParams = new URLSearchParams(location.search);
  searchParams.set('view', 'candidate-contract-editor');
  if (options?.defaultSelection) searchParams.set('default_selection', options?.defaultSelection);
  history(`${location.pathname}?${searchParams.toString()}`);
  /** Scroll to the top of the screen on redirection */
  document.getElementById(appComponentAccessId)?.scrollTo(0, 0);
};
